import { gql } from 'src/generated/gql';

export const GET_MY_DAY_TODAY_CURRENT_STATUS_QUERY = gql(`
  query Staff_GetMyDayTodayCurrentStatus($providerId: ID!) {
    staff_myDayTodayCurrentStatus(providerId: $providerId) {
      tasksCompleted
      visitsCompleted
      avgWaitTime
      clinicVolume
      clinicVolumeLabel
      providersWorking
    }
  }
`);
